<template>
    <div>
        <!--***************************************************개인**********************************************************-->
        <!--개인 TACHYON Internet Security 5.0 -->
        <!--개인 TACHYON Internet Security 5.0 제품 정보 1~4개 FAQ-->
        <div v-if="selContent == 'b2cTis50' && num.includes('m01')" class="sebContTit">
            <ul>
                 <div class="sebContTit">
                    <ul>
                        <!--개인 TACHYON Internet Security 5.0 제품 정보 1 -->
                        <li id="c1" :class="split == '01' ? 'active':'' " @click="selectQues('b2cTis50','m0101')">
                            <span>Q</span>1. What is TACHYON Internet Security 5.0?
                        </li>
                        <div v-if="split == '01'" class="sebContInner">
                            <div class="sebInnerTit">
                                <span>A</span>Answer
                                <input  type="text" id="urlInput" class="url-input"/>
                                <a @click="copyUrl()" class="url-copy-btn"><span>URL</span>Copy</a>
                            </div>
                            <div class="sebContent">
                                <p>Advanced anti-virus solution that blocks cyber threats such as malware, spyware, ransomware, etc. Safely protect user system and important</p>
                                <p>information with improved real-time monitoring and protection features.</p>
                            </div>
                        </div>
                        <!--개인 TACHYON Internet Security 5.0 제품 정보 2 -->
                        <li id="c2" :class="split == '02' ? 'active':'' " @click="selectQues('b2cTis50','m0102')">
                            <span>Q</span>2. What are the features of TACHYON Internet Security 5.0?
                        </li>
                        <div v-if="split == '02'" class="sebContInner">
                            <div class="sebInnerTit">
                                <span>A</span>Answer
                                <input  type="text" id="urlInput" class="url-input"/>
                                <a @click="copyUrl()" class="url-copy-btn"><span>URL</span>Copy</a>
                            </div>
                            <div class="sebContent">
                                <ul>
                                    <li>
                                        <span class="tit">- Antivirus</span>
                                        <p>Signature-Based Detection<br/>Real-time advanced scanning of malwares such as virus and spyware</p>
                                    </li>
                                    <li>
                                        <span class="tit">-Integrity Verification</span>
                                        <p>Product module tampering / hacking verification</p>
                                    </li>
                                    <li>
                                        <span class="tit">-PC Management</span>
                                        <p>Manage installed programs, ActiveX, Start programs and toolbar</p>
                                    </li>
                                    <li>
                                        <span class="tit">-PC Optimization</span>
                                        <p>Manage installed programs, ActiveX, Start programs and toolbar</p>
                                    </li>
                                    <li>
                                        <span class="tit">-Engine Update</span>
                                        <p>Real-time, periodic and emergency updates</p>
                                    </li>
                                    <li>
                                        <span class="tit">-Log</span>
                                        <p>Log data of product and malware detection/clean history</p>
                                    </li>
                                    <li>
                                        <span class="tit">-Additional Features</span>
                                        <p>Product registry, file and process protection<br/>
                                            Backup and restore option in virus quarantine</p>
                                    </li>
                                </ul>


                                <p>Upgrade to TACHYON Endpoint Security by subscribing to use Firewall, APT Protection, MBR Protection, Ransomware Protection features.</p>
                            </div>
                        </div>
                        <!--개인 TACHYON Internet Security 5.0 제품 정보 3 -->
                        <li id="c3" :class="split == '03' ? 'active':'' " @click="selectQues('b2cTis50','m0103')">
                            <span>Q</span>3. Hardware Requirements
                        </li>
                        <div v-if="split == '03'" class="sebContInner">
                            <div class="sebInnerTit">
                                <span>A</span>Answer
                                <input  type="text" id="urlInput" class="url-input"/>
                                <a @click="copyUrl()" class="url-copy-btn"><span>URL</span>Copy</a>
                            </div>
                            <div class="sebContent">
                                <div class="sebTable">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Components</th>
                                                <th colspan="2">Requirements</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td class="tit">Hardware</td>
                                                <td>CPU<br>
                                                    RAM<br>
                                                    Hard Disk
                                                </td>
                                                <td>Intel Pentium 4 3.8 GHz<br>
                                                    2GB or more<br>
                                                    Minimum 20GB of available hard disk space
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <!--개인 TACHYON Internet Security 5.0 제품 정보 4 -->
                        <li id="c4" :class="split == '04' ? 'active':'' " @click="selectQues('b2cTis50','m0104')">
                            <span>Q</span>4. Software Requirements
                        </li>
                        <div v-if="split == '04'" class="sebContInner">
                            <div class="sebInnerTit">
                                <span>A</span>Answer
                                <input  type="text" id="urlInput" class="url-input"/>
                                <a @click="copyUrl()" class="url-copy-btn"><span>URL</span>Copy</a>
                            </div>
                            <div class="sebContent">
                                <h3>-  Support OS</h3>
                                <div class="sebTable">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Components</th>
                                                <th>Requirements</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td class="tit">OS</td>
                                                <td>Windows XP SP3 (32bit)<br>
                                                    Windows Vista SP2 (32/64bit)<br>
                                                    Windows 7 SP1 (32/64bit)<br>
                                                    <!-- Windows 8/8.1 (32/64bit)<br> -->
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </ul>

                </div>
            </ul>

        </div>

        <!--개인 TACHYON Internet Security 5.0 -->
        <!--개인 TACHYON Internet Security 5.0 설치 및 삭제 1~2개 FAQ-->
        <div v-if="selContent == 'b2cTis50' && num.includes('m02')" class="sebContTit">
            <ul>
                <div class="sebContTit">
                    <ul>
                        <!--개인 TACHYON Internet Security 5.0 설치 및 삭제 1-->
                        <li id="c1" :class="split == '01' ? 'active':'' " @click="selectQues('b2cTis50','m0201')">
                            <span>Q</span>1. TACHYON Internet Security 5.0 Install guide
                        </li>
                        <div v-if="split == '01'" class="sebContInner">
                            <div class="sebInnerTit">
                                <span>A</span> Answer
                                <input  type="text" id="urlInput" class="url-input"/>
                                <a @click="copyUrl()" class="url-copy-btn"><span>URL</span>Copy</a>
                            </div>
                            <div class="sebContent">
                                <p class="tit">Install Guide</p>

                                <ul>
                                    <li>
                                        <p>Execute the downloaded TIS_Launcher.exe to download TACHYON Internet Security 5.0 install file.</p>
                                        <img src="@/assets/img/cs/tis/en_tis1.png"/>
                                        <p>Execute TIS_Launcher</p>
                                        <br/>
                                        <img src="@/assets/img/cs/tis/en_tis2.png"/>
                                        <p>Downloading install file</p>
                                        <br/>
                                        <img src="@/assets/img/cs/tis/en_tis3.png"/>
                                        <p>Downloading install file</p>
                                        <br/>
                                    </li>
                                    <li>
                                        <p>Installation will proceed automatically after the download is complete</p>
                                        <img src="@/assets/img/cs/tis/en_tis4.png"/>
                                        <p>Start Installation</p>
                                        <br/>
                                        <img src="@/assets/img/cs/tis/en_tis5.png"/>
                                        <p>License Agreement</p>
                                        <br/>
                                        <img src="@/assets/img/cs/tis/en_tis6.png"/>
                                        <p>Data Collection Agreement</p>
                                        <br/>
                                        <img src="@/assets/img/cs/tis/en_tis7.png"/>
                                        <p>Installation Completed</p>
                                        <br/>
                                    </li>
                                    <li>
                                        <p>After the installation is completed, the screen as shown below appears and module and pattern update will be executed automatically.</p>
                                        <img src="@/assets/img/cs/tis/en_tis8.png"/>
                                        <img src="@/assets/img/cs/tis/en_tis9.png"/>
                                        <br/>
                                    </li>
                                    <li>
                                        <p>When the installation is completed, right click the [ <img src="@/assets/img/cs/common/tachyon.png" align="center"/> ] icon on the right side of Windows tray to execute TACHYON Internet Security 5.0 Open and the screen as shown below appears</p>
                                        <img src="@/assets/img/cs/tis/en_tis11.png"/>
                                        <img src="@/assets/img/cs/tis/en_tis10.png" align="top"/>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <!--개인 TACHYON Internet Security 5.0 설치 및 삭제 2-->
                        <li id="c2" :class="split == '02' ? 'active':'' " @click="selectQues('b2cTis50','m0202')">
                            <span>Q</span>2. TACHYON Internet Security 5.0 uninstall guide
                        </li>
                        <div v-if="split == '02'" class="sebContInner">
                            <div class="sebInnerTit">
                                <span>A</span> Answer
                                <input  type="text" id="urlInput" class="url-input"/>
                                <a @click="copyUrl()" class="url-copy-btn"><span>URL</span>Copy</a>
                            </div>
                            <div class="sebContent">
                                <p class="tit">Uninstall Guide (Control Panel method)</p>
                                <ul>
                                    <li>
                                        <p>After click the Start button, click Windows System > Control Panel from the program list.</p>
                                        <img src="@/assets/img/cs/tis/en_tis_uninstall1.png"/>
                                    </li>
                                    <li>
                                        <p>When the Control Panel is opened, click Programs > Uninstall a program menu at the bottom.</p>
                                        <img src="@/assets/img/cs/tis/en_tis_uninstall2.png"/>
                                    </li>
                                    <li>
                                        <p>Select TACHYON Internet Security 5.0 and click Uninstall/Change to proceed with uninstall.</p>
                                        <img src="@/assets/img/cs/tis/en_tis_uninstall3.png"/>
                                    </li>
                                    <li>
                                        <p>Please follow below instructions to proceed with uninstall</p>
                                        <img src="@/assets/img/cs/tis/en_tis_uninstall4.png"/>
                                        <p>Execute uninstall program</p>
                                        <br/>
                                        <img src="@/assets/img/cs/tis/en_tis_uninstall5.png"/>
                                        <p>Select components and click Uninstall</p>
                                        <br/>
                                        <img src="@/assets/img/cs/tis/en_tis_uninstall6.png"/>
                                        <p>To delete some files, Click Yes to restart Explorer.exe.</p>
                                        <br/>
                                        <img src="@/assets/img/cs/tis/en_tis_uninstall7.png"/>
                                        <p>Click Finish to complete uninstall.</p>
                                        <br/>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </ul>
                </div>
            </ul>
        </div>

        <!--개인 TACHYON Internet Security 5.0 -->
        <!--개인 TACHYON Internet Security 5.0 주요 문의 1개 FAQ -->
        <div v-if="selContent == 'b2cTis50' && num.includes('m03')" class="sebContTit">
            <ul>
                <div class="sebContTit">
                    <ul>
                        <!--개인 TACHYON Internet Security 5.0 주요 문의 1-->
                        <li id="c1" :class="split == '01' ? 'active':'' " @click="selectQues('b2cTis50','m0301')">
                            <span>Q</span>1. Starting TACHYON Internet Security 5.0
                        </li>
                        <div v-if="split == '01'" class="sebContInner">
                            <div class="sebInnerTit">
                                <span>A</span> Answer
                                <input  type="text" id="urlInput" class="url-input"/>
                                <a @click="copyUrl()" class="url-copy-btn"><span>URL</span>Copy</a>
                            </div>
                            <div class="sebContent">
                                <p>Basically, it is automatically executed after the installation is completed and when the operating system is started. it always protects the user's system from internal and external threats </p>
                                <br/>
                                <p>Also, the product can be started by the user.</p>
                                <br/>
                                <p>it can be executed by double click the "TACHYON Internet Security 5.0" icon installed on the desktop, double click the tray icon[ <span><img src="@/assets/img/cs/common/tachyon.png" align="center"/></span> ] or by selecting "TACHYON Internet Security 5.0 Open" menu from the right mouse button menu.</p>
                            </div>
                        </div>
                    </ul>
                </div>
            </ul>
        </div>


























        <!--개인 TACHYON Internet Security 6.0 -->
        <!--개인 TACHYON Internet Security 6.0 제품 정보 1~4개 FAQ-->
        <div v-if="selContent == 'b2cTis60' && num.includes('m01')" class="sebContTit">
            <ul>
                 <div class="sebContTit">
                    <ul>
                        <!--개인 TACHYON Internet Security 6.0 제품 정보 1 -->
                        <li id="c1" :class="split == '01' ? 'active':'' "  @click="selectQues('b2cTis60','m0101')">
                            <span>Q</span>1. What is TACHYON Internet Security 6.0?
                        </li>
                        <div v-if="split == '01'" class="sebContInner">
                            <div class="sebInnerTit">
                                <span>A</span>Answer
                                <input  type="text" id="urlInput" class="url-input"/>
                                 <a @click="copyUrl()" class="url-copy-btn"><span>URL</span>Copy</a>
                            </div>
                            <div class="sebContent">
                                <p>Advanced anti-virus solution that blocks cyber threats such as malware, spyware, ransomware, etc. Safely protect user system and important</p>
                                <p>information with improved real-time monitoring and protection features.</p>
                            </div>
                        </div>
                        <!--개인 TACHYON Internet Security 6.0 제품 정보 2 -->
                        <li id="c2" :class="split == '02' ? 'active':'' "  @click="selectQues('b2cTis60','m0102')">
                            <span>Q</span>2. What are the features of TACHYON Internet Security 6.0?
                        </li>
                        <div v-if="split == '02'" class="sebContInner">
                            <div class="sebInnerTit">
                                <span>A</span>Answer
                                <input  type="text" id="urlInput" class="url-input"/>
                                <a @click="copyUrl()" class="url-copy-btn"><span>URL</span>Copy</a>
                            </div>
                            <div class="sebContent">
                                <ul>
                                    <li>
                                        <span class="tit">- Anti-Malware</span>
                                        <p>
                                            Real-time advanced scanning of malwares such as virus, spyware and ransomware</br>
                                            Various file format analysis and multi-detection</br>
                                            Detecting macro virus in Microsoft Office</br>
                                            Removing malware exploits in PDF document
                                        </p>
                                    </li>
                                    <li>
                                        <span class="tit">- Behavior-Based Detection</span>
                                        <p>
                                            Protection against new and emerging malware<br/>
                                            APT attack prevention<br/>
                                        </p>
                                    </li>
                                    <li>
                                        <span class="tit">- Ransomware Prevention</span>
                                        <p>
                                            Detecting and blocking suspicious ransomware program<br/>
                                            File encryption and damage prevention
                                        </p>
                                    </li>
                                    <li>
                                        <span class="tit">- MBR Protection</span>
                                        <p>
                                            Anti-hacking for MBR<br/>
                                            Preventing PC start up fail and data damage<br/>
                                        </p>
                                    </li>
                                    <li>
                                        <span class="tit">- Network Prevention</span>
                                        <p>
                                            Preventing hacking with real-time network protection<br/>
                                            Blocking un-authorized incoming traffic<br/>
                                            Shared folder monitoring and access management<br/>
                                            External protocol program detection and alert system<br/>
                                            Un-authorized access detection and blocking through IP/Port
                                        </p>
                                    </li>
                                    <li>
                                        <span class="tit">- Self-Protection</span>
                                        <p>Product itself, registry, file and process protection </p>
                                    </li>
                                    <li>
                                        <span class="tit">- Update</span>
                                        <p>
                                            Real-time, periodic and emergency pattern and product updates<br/>
                                            Periodic pattern and product update through reservation setting<br/>
                                            Auto and manual updates
                                        </p>
                                    </li>
                                    <li>
                                        <span class="tit">- Log</span>
                                        <p>Logging data of product and malware detection/cure/delete history</p>
                                    </li>
                                    <li>
                                        <span class="tit">- Quarantine</span>
                                        <p>Backup and restore option in quarantine</p>
                                    </li>
                                    <li>
                                        <span class="tit">- System Optimization</span>
                                        <p>Optimize PC environment including network speed, memory usage and system settings</p>
                                    </li>
                                    <li>
                                        <span class="tit">- System Cleanup</span>
                                        <p>Manage installed programs, ActiveX, Start programs and toolbar</p>
                                    </li>
                                    <li>
                                        <span class="tit">- Windows Patch Management</span>
                                        <p>
                                            Check for Windows Update<br/>
                                            Select and install/uninstall Windows updates
                                        </p>
                                    </li>
                                    <li>
                                        <span class="tit">- File Wiper</span>
                                        <p>
                                            Supports the feature of wiping file and folder completely<br/>
                                            Supports 3 types of wiping file algorithm and feature to wipe file using a wanted algorithm<br/>
                                            Prevents file recovery by repeatedly overwriting data in a wiped data spaces
                                        </p>
                                    </li>
                                    <li>
                                        <span class="tit">- Disk Wiper</span>
                                        <p>
                                            Supports the feature of initializing disk and partition completely.<br/>
                                            Supports 3 types of disk initialization algorithms, and can initialize disks with the wanted algorithm.
                                        </p>
                                    </li>
                                    <li>
                                        <span class="tit">- File Encrypt/Decrypt</span>
                                        <p>
                                            Supports file and folder encryption and decryption.<br/>
                                            Supports 5 types of file and folder encryption algorithms, enables encryption with the desired algorithm.
                                        </p>
                                    </li>
                                    <li>
                                        <span class="tit">- Hash Viewer</span>
                                        <p>Hash view and hash comparison for files</p>
                                    </li>
                                    <li>
                                        <span class="tit">- Security Policy Detector</span>
                                        <p>
                                            Vulnerable PC security checks<br/>
                                            PC security can be set to be safe.
                                        </p>
                                    </li>
                                </ul>
                                <br>
                                <!-- <p>방화벽, 행위기반 탐지, MBR 보호, 랜섬웨어 차단과 같은 프리미어 기능은 결제 후 사용하실 수 <br>있습니다.</p> -->
                            </div>
                        </div>
                        <!--개인 TACHYON Internet Security 6.0 제품 정보 3 -->
                        <li id="c3" :class="split == '03' ? 'active':'' " @click="selectQues('b2cTis60','m0103')">
                            <span>Q</span>3. Hardware Requirements
                        </li>
                        <div v-if="split == '03'" class="sebContInner">
                            <div class="sebInnerTit">
                                <span>A</span>Answer
                                <input  type="text" id="urlInput" class="url-input"/>
                                <a @click="copyUrl()" class="url-copy-btn"><span>URL</span>Copy</a>
                            </div>
                            <div class="sebContent">
                                <div class="sebTable">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Components</th>
                                                <th colspan="2">Requirements</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td class="tit">Hardware</td>
                                                <td>CPU<br>
                                                    RAM<br>
                                                    Hard Disk
                                                </td>
                                                <td>Intel Pentium 4 3.8 GHz<br>
                                                    2GB or more<br>
                                                    20GB or more
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                        <!--개인 TACHYON Internet Security 6.0 제품 정보 4 -->
                        <li id="c4" :class="split == '04' ? 'active':'' " @click="selectQues('b2cTis60','m0104')">
                            <span>Q</span>4. Software Requirements
                        </li>
                        <div v-if="split == '04'" class="sebContInner">
                            <div class="sebInnerTit">
                                <span>A</span>Answer
                                <input  type="text" id="urlInput" class="url-input"/>
                                <a @click="copyUrl()" class="url-copy-btn"><span>URL</span>Copy</a>
                            </div>
                            <div class="sebContent">
                                <h3>- Support OS</h3>
                                <div class="sebTable">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Components</th>
                                                <th>Requirements</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td class="tit">OS</td>
                                                <td>
                                                    Windows 8/8.1 (32bit, 64bit)<br>
                                                    Windows 10 (32/64bit)<br>
                                                    Windows 11 (64bit)<br>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </ul>

                </div>
            </ul>

        </div>

        <!--개인 TACHYON Internet Security 6.0 -->
        <!--개인 TACHYON Internet Security 6.0 설치 및 삭제 1~2개 FAQ-->
        <div v-if="selContent == 'b2cTis60' && num.includes('m02')" class="sebContTit">
            <ul>
                <div class="sebContTit">
                    <ul>
                        <!--개인 TACHYON Internet Security 6.0 설치 및 삭제 1-->
                        <li id="c1" :class="split == '01' ? 'active':'' "  @click="selectQues('b2cTis60','m0201')">
                            <span>Q</span>1. TACHYON Internet Security 6.0 Install guide
                        </li>
                        <div v-if="split == '01'" class="sebContInner">
                            <div class="sebInnerTit">
                                <span>A</span> Answer
                                <input  type="text" id="urlInput" class="url-input"/>
                                <a @click="copyUrl()" class="url-copy-btn"><span>URL</span>Copy</a>
                            </div>
                            <div class="sebContent">
                                <p class="tit">Install Guide</p>

                                <ul>
                                    <li>
                                        <p>Double click or right click “TIS60_Trial.exe” to open(O) a file to start installation.</p>
                                        <img src="@/assets/img/cs/tis60/en_tis60_1.png"/>
                                        <p></p>
                                        <br/>
                                        <p>Download installation file of TACHYON Internet Security 6.0.</p>
                                        <img src="@/assets/img/cs/tis60/en_tis60_2.png"/>
                                        <p></p>
                                        <br/>
                                        <p>Click [NEXT] button in the welcome screen.</p>
                                        <img src="@/assets/img/cs/tis60/en_tis60_3.png"/>
                                        <p></p>
                                        <br/>
                                        <p>Check the “I accept the terms of the License Agreement.” In the license agreement screen and then click the [Next] button.</p>
                                        <img src="@/assets/img/cs/tis60/en_tis60_4.png"/>
                                        <p></p>
                                        <br/>
                                        <p>Check the “I agree to the Data Collection Agreement.” in the license agreement screen and then click the [Next] button.</p>
                                        <img src="@/assets/img/cs/tis60/en_tis60_5.png"/>
                                        <p></p>
                                        <br/>
                                        <p>Software installation will be proceeded. Please wait until the installation process is completed.</p>
                                        <img src="@/assets/img/cs/tis60/en_tis60_6.png"/>
                                        <img src="@/assets/img/cs/tis60/en_tis60_7.png"/>
                                        <p></p>
                                        <br/>
                                        <p>When the installation is complete, click [Finish].</p>
                                        <img src="@/assets/img/cs/tis60/en_tis60_8.png"/>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <!--개인 TACHYON Internet Security 6.0 설치 및 삭제 2-->
                        <li id="c2" :class="split == '02' ? 'active':'' "  @click="selectQues('b2cTis60','m0202')">
                            <span>Q</span>2. TACHYON Internet Security 6.0 uninstall guide
                        </li>
                        <div v-if="split == '02'" class="sebContInner">
                            <div class="sebInnerTit">
                                <span>A</span> Answer
                                <input  type="text" id="urlInput" class="url-input"/>
                                <a @click="copyUrl()" class="url-copy-btn"><span>URL</span>Copy</a>
                            </div>
                            <div class="sebContent">
                                <p class="tit">Uninstall Guide</p>
                                <ul>
                                    <li>
                                        <p>Run “Programs and Features” from Windows Control Panel. Select TACHYON Internet Security 6.0 and click [Uninstall/Change].</p>
                                        <img src="@/assets/img/cs/tis60/en_tis60_uninstall1.png"/>
                                        <p></p>
                                        <br/>
                                        <p>When user is ready to uninstall, start deleting the product. Click [NEXT] button to proceed.</p>
                                        <img src="@/assets/img/cs/tis60/en_tis60_uninstall2.png"/>
                                        <p></p>
                                        <br/>
                                        <p>Click [Remove] button after choosing items to be deleted.</p>
                                        <img src="@/assets/img/cs/tis60/en_tis60_uninstall3.png"/>
                                        <p></p>
                                        <br/>
                                        <p>During the uninstallation, the progress bar is displayed for a while.</p>
                                        <img src="@/assets/img/cs/tis60/en_tis60_uninstall4.png"/>
                                        <p></p>
                                        <br/>
                                        <p>When all product files were deleted, click [Finish] to complete uninstallation of TACHYON Internet Security 6.0.</p>
                                        <img src="@/assets/img/cs/tis60/en_tis60_uninstall5.png"/>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </ul>

                </div>
            </ul>

        </div>


        <!--개인 TACHYON Internet Security 6.0 -->
        <!--개인 TACHYON Internet Security 6.0 주요 문의 1개 FAQ -->
        <div v-if="selContent == 'b2cTis60' && num.includes('m03')" class="sebContTit">
            <ul>
                <div class="sebContTit">
                    <ul>
                        <!--개인 TACHYON Internet Security 5.0 주요 문의 1-->
                        <li id="c1" :class="split == '01' ? 'active':'' " @click="selectQues('b2cTis60','m0301')">
                            <span>Q</span>1. Starting TACHYON Internet Security 6.0
                        </li>
                        <div v-if="split == '01'" class="sebContInner">
                            <div class="sebInnerTit">
                                <span>A</span> Answer
                                <input  type="text" id="urlInput" class="url-input"/>
                                <a @click="copyUrl()" class="url-copy-btn"><span>URL</span>Copy</a>
                            </div>
                            <div class="sebContent">
                                <p>Basically, it is automatically executed after the installation is completed and when the operating system is started. it always protects the user's system from internal and external threats </p>
                                <br/>
                                <p>Also, the product can be started by the user.</p>
                                <br/>
                                <p>it can be executed by double click the "TACHYON Internet Security 6.0" icon installed on the desktop, double click the tray icon[ <span><img src="@/assets/img/cs/common/tachyon.png" align="center"/></span> ] or by selecting "TACHYON Internet Security 6.0 Open" menu from the right mouse button menu.</p>
                            </div>
                        </div>
                    </ul>

                </div>
            </ul>

        </div>



































        <!--***************************************************기업**********************************************************-->
        <!--기업 TACHYON Endpoint Security 5.0 -->
        <!--기업 TACHYON Endpoint Security 5.0 제품 정보 1~4개 FAQ-->
        <div v-if="selContent == 'b2bTes50' && num.includes('m01')" class="sebContTit">
            <ul>
                 <div class="sebContTit">
                    <ul>
                        <!--기업 TACHYON Endpoint Security 5.0 제품 정보 1 -->
                        <li id="c1" :class="split == '01' ? 'active':'' " @click="selectQues('b2bTes50','m0101')">
                            <span>Q</span>1. What is TACHYON Endpoint Security 5.0?
                        </li>
                        <div v-if="split == '01'" class="sebContInner">
                            <div class="sebInnerTit">
                                <span>A</span> Answer
                                <input  type="text" id="urlInput" class="url-input"/>
                                <a @click="copyUrl()" class="url-copy-btn"><span>URL</span>Copy</a>
                            </div>
                            <div class="sebContent">
                                <p>Advanced anti-virus solution that blocks cyber threats such as malware, spyware, ransomware, etc.</p>
                                <p>Safely protect user system and important information with improved real-time monitoring and protection features.</p>
                            </div>
                        </div>
                        <!--기업 TACHYON Endpoint Security 5.0 제품 정보 2 -->
                        <li id="c2" :class="split == '02' ? 'active':'' " @click="selectQues('b2bTes50','m0102')">
                            <span>Q</span>2. What are the features of TACHYON Endpoint Security 5.0?
                        </li>
                        <div v-if="split == '02'" class="sebContInner">
                            <div class="sebInnerTit">
                                <span>A</span> Answer
                                <input  type="text" id="urlInput" class="url-input"/>
                                <a @click="copyUrl()" class="url-copy-btn"><span>URL</span>Copy</a>
                            </div>
                            <div class="sebContent">
                                <ul>
                                    <li>
                                        <span class="tit">- Antivirus</span>
                                        <p>Signature-Based Detection<br/>
                                            Real-time advanced scanning of malwares such as virus and spyware<br/>
                                            Various file format analysis and multi-detection<br/>
                                            Detects macro virus in Microsoft Office<br/>
                                            Removes malware exploits in PDF document</p>
                                    </li>
                                    <li>
                                        <span class="tit">- Behavior-Based Detection</span>
                                        <p>Protection against new and emerging malware<br/>
                                            APT attack prevention</p>
                                    </li>
                                    <li>
                                        <span class="tit">- Ransomware Protection</span>
                                        <p>Detects and blocks suspicious ransomware program<br/>
                                            File encryption and damage prevention</p>
                                    </li>
                                    <li>
                                        <span class="tit">- MBR Protection</span>
                                        <p>Anti-hacking for MBR<br/>
                                            Prevents PC start up fail and data damage</p>
                                    </li>
                                    <li>
                                        <span class="tit">- Firewall</span>
                                        <p>Prevents hacking with real-time network protection<br/>
                                            Monitor shared folders and manage access to folders<br/>
                                            External protocol program detection and alert system<br/>
                                            Un-authorized access detection through IP/Port monitoring</p>
                                    </li>
                                    <li>
                                        <span class="tit">- Device Control</span>
                                        <p>Block removable media like USB drives and CD/DVD-ROMS from accessing the computer</p>
                                    </li>
                                    <li>
                                        <span class="tit">- Wipe File</span>
                                        <p>Supports the feature of wiping file and folder completely.<br/>
                                        Supports 4 types of wiping file algorithm and feature to wipe file using a wanted algorithm.<br/>
                                        Prevents file recovery by repeatedly overwriting data in a wiped data spaces</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <!--기업 TACHYON Endpoint Security 5.0 제품 정보 3 -->
                        <li id="c3" :class="split == '03' ? 'active':'' " @click="selectQues('b2bTes50','m0103')">
                            <span>Q</span>3. Hardware Requirements
                        </li>
                        <div v-if="split == '03'" class="sebContInner">
                            <div class="sebInnerTit">
                                <span>A</span> Answer
                                <input  type="text" id="urlInput" class="url-input"/>
                                <a @click="copyUrl()" class="url-copy-btn"><span>URL</span>Copy</a>
                            </div>
                            <div class="sebContent">
                                <div class="sebTable">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th> Components </th>
                                                <th colspan="2"> Requirements </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td rowspan="3"> Hardware </td>
                                                <td>CPU<br>
                                                    RAM<br>
                                                    Hard Disk
                                                </td>
                                                <td>Intel Pentium 4 3.8 GHz<br>
                                                    2GB or more<br>
                                                    Minimum 20GB of available hard disk space
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                            </div>
                            </div>
                        </div>
                        <!--기업 TACHYON Endpoint Security 5.0 제품 정보 4 -->
                        <li id="c4" :class="split == '04' ? 'active':'' " @click="selectQues('b2bTes50','m0104')">
                            <span>Q</span>4. Software Requirements
                        </li>
                        <div v-if="split == '04'" class="sebContInner">
                            <div class="sebInnerTit">
                                <span>A</span> Answer
                                <input  type="text" id="urlInput" class="url-input"/>
                                <a @click="copyUrl()" class="url-copy-btn"><span>URL</span>Copy</a>
                            </div>
                            <div class="sebContent">
                                <h3> • Support OS </h3>
                                <div class="sebTable">
                                    <table>
                                        <thead>
                                            <tr>
                                                <th>Components</th>
                                                <th>Requirements</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td class="tit">OS</td>
                                                <td>Windows XP SP3 (32bit)<br>
                                                    Windows Vista SP2 (32/64bit)<br>
                                                    Windows 7 SP1 (32/64bit)<br>
                                                    Windows 8 (32/64bit)<br>
                                                    Windows 8.1 (32/64bit)<br>
                                                    Windows 10 (32/64bit)<br>
                                                    Windows 11 (64bit)<br>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </ul>

                </div>
            </ul>

        </div>


        <!--기업 TACHYON Endpoint Security 5.0 -->
        <!--기업 TACHYON Endpoint Security 5.0 주요 문의 1~4개 FAQ-->
        <div v-if="selContent == 'b2bTes50' && num.includes('m02')" class="sebContTit">
            <ul>
                <!--기업 TACHYON Endpoint Security 5.0 주요 문의 1 -->
                <li id="c1" :class="split == '01' ? 'active':'' " @click="selectQues('b2bTes50','m0201')">
                    <span>Q</span>1. Starting TACHYON Endpoint Security 5.0
                </li>
                <div v-if="split == '01'" class="sebContInner">
                    <div class="sebInnerTit">
                        <span>A</span> Answer
                        <input  type="text" id="urlInput" class="url-input"/>
                        <a @click="copyUrl()" class="url-copy-btn"><span>URL</span>Copy</a>
                    </div>
                    <div class="sebContent">
                        <p>When TACHYON Internet Security 5.0 is paid after installation, it will be converted to TACHYON Endpoint Security 5.0 and user can use all the features.</p>
                    </div>
                </div>
                <!--기업 TACHYON Endpoint Security 5.0 주요 문의 2 -->
                <li id="c2" :class="split == '02' ? 'active':'' "  @click="selectQues('b2bTes50','m0202')">
                    <span>Q</span>2. Do I need administrator privileges?
                </li>
                <div v-if="split == '02'" class="sebContInner">
                    <div class="sebInnerTit">
                        <span>A</span> Answer
                        <input  type="text" id="urlInput" class="url-input"/>
                        <a @click="copyUrl()" class="url-copy-btn"><span>URL</span>Copy</a>
                    </div>
                    <div class="sebContent">
                        <p>TACHYON Endpoint Security 5.0 does not run properly because the Windows Guest account does not have sufficient privileges to control the service.</p>
                    </div>
                </div>
                <!--기업 TACHYON Endpoint Security 5.0 주요 문의 3 -->
                <li id="c3" :class="split == '03' ? 'active':'' " @click="selectQues('b2bTes50','m0203')">
                    <span>Q</span>3. After installing TACHYON Endpoint Security 5.0, I see a folder with <br/> &nbsp;&ensp;&emsp;&emsp;&emsp;&emsp;special characters on my PC hard disk. Can I delete it?
                </li>
                <div v-if="split == '03'" class="sebContInner">
                    <div class="sebInnerTit">
                        <span>Q</span> Question
                        <input  type="text" id="urlInput" class="url-input"/>
                        <a @click="copyUrl()" class="url-copy-btn"><span>URL</span>Copy</a>
                    </div>
                    <div class="sebContent">
                        <p>After installing TACHYON Endpoint Security 5.0, I see a folder with special characters on my PC hard disk. Can I delete it?</p>
                        <img src="@/assets/img/cs/common/en_imgs1.png"/>
                    </div>
                    <div class="sebInnerTit">
                        <span>A</span> Answer
                    </div>
                    <div class="sebContent">
                        <p>The [(Mixed-Special Characters)]folders in each drive is for ransomware protection. <br/>
                        Ransomware protection will be stopped if the folders are deleted. </p>
                    </div>
                </div>
                <!--기업 TACHYON Endpoint Security 5.0 주요 문의 4 -->
                <li id="c4" :class="split == '04' ? 'active':'' "  @click="selectQues('b2bTes50','m0204')">
                    <span>Q</span>4. Another anti-virus is already installed
                </li>
                <div v-if="split == '04'" class="sebContInner">
                    <div class="sebInnerTit">
                        <span>A</span> Answer
                        <input  type="text" id="urlInput" class="url-input"/>
                        <a @click="copyUrl()" class="url-copy-btn"><span>URL</span>Copy</a>
                    </div>
                    <div class="sebContent">
                        <p>TACHYON Endpoint Security 5.0 may crash if the PC has other anti-virus or similar software already installed. It is recommended that the existing software is deleted before installing the TACHYON Endpoint Security 5.0 software.  </p>
                        <br/>
                        <p>If more than one anti-virus software needs to be installed then please turn off the real-time scan feature of the existing anti-virus software and install TACHYON Endpoint Security 5.0 software. </p>
                    </div>
                </div>
            </ul>

        </div>


        <!--**********************************************************공통**********************************************************-->
        <!-- 공통 -->
        <!-- 공통 주요 문의 1~7개 FAQ-->
        <div v-if="selContent == 'common' && num.includes('m01')" class="sebContTit">
            <ul>
                <div class="sebContTit">
                    <ul>
                        <!-- 공통 주요 문의 1 -->
                        <li id="c1" :class="split == '01' ? 'active':'' " @click="selectQues('common','m0101')">
                            <span>Q</span>1. What should I do if I see a message that malware was detected?
                        </li>
                        <div v-if="split == '01'" class="sebContInner">
                            <div  style="margin-top: 3rem; text-align: center;">
                                <img src="@/assets/img/cs/common/en_imgs2.png" style="width:40%; margin-right:6%;" />
                                <img src="@/assets/img/cs/common/en_imgs11.png" style="width:40%;" />
                                <p class="quesPic"><span style="margin-right:21%;">TACHYON Internet Security 5.0</span> <span>TACHYON Internet Security 6.0</span></p>
                            </div>
                            <div class="sebInnerTit">
                                <span>A</span> Answer
                                <input  type="text" id="urlInput" class="url-input"/>
                                <a @click="copyUrl()" class="url-copy-btn"><span>URL</span>Copy</a>
                            </div>
                            <div class="sebContent">
                                <p>This message is generated when malware is detected while real-time monitoring is turned on.</p>
                                <br/>
                                <p>After check the program path, clean malware with "Clean All" or "Selected items clean"</p>
                                <br/>
                                <p>Malware can be used for information leak by using programs that are usually generated without user's consent. If the code is classified as malicious, it can be detected and the diagnosis / clean through the vaccine program may be needed to solve the problems.</p>
                            </div>
                        </div>
                        <!-- 공통 주요 문의 2 -->
                        <li id="c2" :class="split == '02' ? 'active':'' " @click="selectQues('common','m0102')">
                            <span>Q</span>2. What to do if the same virus has detected after the cleaning?
                        </li>
                        <div v-if="split == '02'" class="sebContInner">
                            <div class="sebInnerTit">
                                <span>A</span> Answer
                                <input  type="text" id="urlInput" class="url-input"/>
                                <a @click="copyUrl()" class="url-copy-btn"><span>URL</span>Copy</a>
                            </div>
                            <div class="sebContent">
                                <p>As soon as the infected virus is cleaned, the virus may be spread to other files, causing further infections. Please boot the PC into safe mode and scan and clean.</p>
                            </div>
                        </div>
                        <!-- 공통 주요 문의 3 -->
                        <li id="c3" :class="split == '03' ? 'active':'' "  @click="selectQues('common','m0103')">
                            <span>Q</span>3. How to restore a file from quarantine?
                        </li>
                        <div v-if="split == '03'" class="sebContInner">
                            <div class="sebInnerTit">
                                <span>A</span> Answer
                                <input  type="text" id="urlInput" class="url-input"/>
                                <a @click="copyUrl()" class="url-copy-btn"><span>URL</span>Copy</a>
                            </div>
                            <div class="sebContent">
                                <p>TACHYON products encrypt this file so that it won't run if a virus is detected.</p>
                                <p>Clicking quarantine in the menu allows user to restore or delete after check it.</p>
                                <br/>
                                <p>When restoring, the file is restored to its original file before being quarantined in the path specified in</p>
                                <p>
                                    <span class="tit">- TACHYON Internet Security 5.0 & TACHYON Endpoint Security 5.0</span><br/>
                                    "ETC>Quarantine>Quarantine>Select recovery folder" of the "Settings" functions.<br/>
                                    <span class="tit">- TACHYON Internet Security 6.0 & TACHYON Endpoint Security 6.0</span><br/>
                                    "Logs>Quarantine"
                                </p>
                                <br/>
                                <p>if users do not specify a folder, the default folders for this product are as follows.</p>
                                <p>
                                    <span class="tit">- TACHYON Internet Security 5.0</span><br/>
                                    C:\Program Files\Common Files\TACHYON\T5\Quarantine\Restore(32bit)<br/>
                                    C:\Program Files (x86)\Common Files\TACHYON\T5\Quarantine\Restore(64bit)<br/>
                                    <span class="tit">- TACHYON Internet Security 6.0</span><br/>
                                    C:\ProgramData\TACHYON\T6\quarantine\Restore(32bit, 64bit)
                                </p>
                                <br/>
                                <p>If user delete it, it will not be restored.</p>
                            </div>
                        </div>
                        <!-- 공통 주요 문의 4 -->
                        <li id="c4" :class="split == '04' ? 'active':'' " @click="selectQues('common','m0104')">
                            <span>Q</span>4. The Fix button is disabled in the Security Center. What should I do?
                        </li>
                        <div v-if="split == '04'" class="sebContInner">
                            <div class="sebInnerTit">
                                <span>A</span> Answer
                                <input  type="text" id="urlInput" class="url-input"/>
                                <a @click="copyUrl()" class="url-copy-btn"><span>URL</span>Copy</a>
                            </div>
                            <div class="sebContent">
                                <p>In the Security Center, the [Fix] button is abled in the following cases.</p>
                                <ul>
                                    <li>If any of the real-time protection features (Real-time Monitoring, / APT Protection / MBR Protection / Ransomware Protection) is OFF.</li>
                                    <li>If the engine file is not up to date.</li>
                                    <li>If any threats exist found by the scan.</li>
                                </ul>
                            </div>
                        </div>
                        <!-- 공통 주요 문의 5 -->
                        <li id="c5" :class="split == '05' ? 'active':'' "  @click="selectQues('common','m0105')">
                            <span>Q</span>5. How is the grade of status displayed in security center?
                        </li>
                        <div v-if="split == '05'" class="sebContInner">
                            <div class="sebInnerTit">
                                <span>A</span> Answer
                                <input  type="text" id="urlInput" class="url-input"/>
                                <a @click="copyUrl()" class="url-copy-btn"><span>URL</span>Copy</a>
                            </div>
                            <div class="sebContent">
                                <p>The Security Center displays three levels of security status for users system and product.</p>
                                <p>Each level notifies what to check, so using the information of Security Center, users can identify and act on the security issues.</p>
                                <ul>
                                        <li>
                                            <span class="tit">- Safety<br/></span>
                                            <img src="@/assets/img/cs/common/en_imgs3.png" style="width:45%; margin-right:10%;"/>
                                            <img src="@/assets/img/cs/common/en_imgs12.png" style="width:45%"/>
                                            <p class="quesPic" style="text-align:center;"><span style="margin-right:18%;">TACHYON Internet Security 5.0</span> <span>TACHYON Internet Security 6.0</span></p>
                                            <p>If the features of real-time monitoring(Real-Time scan/ APT Protection / MBR Protection) are in normal operation and update items and threats do not exist.</p>
                                        </li>
                                        <li>
                                            <span class="tit">- Warning<br/></span>
                                            <img src="@/assets/img/cs/common/en_imgs4.png" style="width:45%; margin-right:10%;"/>
                                            <img src="@/assets/img/cs/common/en_imgs13.png" style="width:45%"/>
                                            <p class="quesPic" style="text-align:center;"><span style="margin-right:18%;">TACHYON Internet Security 5.0</span> <span>TACHYON Internet Security 6.0</span></p>
                                            <p>If the features of real-time monitoring(Real-Time scan/ APT Protection / MBR Protection) are in normal operation but the latest update items and threats exist.</p>
                                        </li>
                                        <li>
                                            <span class="tit">- Danger<br/></span>
                                            <img src="@/assets/img/cs/common/en_imgs5.png" style="width:45%; margin-right:10%;"/>
                                            <img src="@/assets/img/cs/common/en_imgs14.png" style="width:45%"/>
                                            <p class="quesPic" style="text-align:center;"><span style="margin-right:18%;">TACHYON Internet Security 5.0</span> <span>TACHYON Internet Security 6.0</span></p>
                                            <p>If any of the features of real-time monitoring(Real-Time scan/ APT Protection / MBR Protection) is stopped.</p>
                                        </li>
                                    </ul>
                            </div>
                        </div>
                        <!-- 공통 주요 문의 6 -->
                        <li id="c6" :class="split == '06' ? 'active':'' "  @click="selectQues('common','m0106')">
                            <span>Q</span>6. What should I do if I get a "Failed to download update information"<br/> &nbsp;&ensp;&emsp;&emsp;&emsp;&emsp;message when running update?
                        </li>
                        <div v-if="split == '06'" class="sebContInner">
                            <div  style="margin-top: 3rem; text-align: center;">
                                <img src="@/assets/img/cs/common/en_imgs6.png" style="width:40%; margin-right:5%;"/>
                                <img src="@/assets/img/cs/common/en_imgs15.png" style="width:50%;"/>
                                <p class="quesPic" style="text-align:left;"><span style="margin-right:26%; margin-left:10%;">TACHYON Internet Security 5.0</span> <span>TACHYON Internet Security 6.0</span></p>
                            </div>
                            <!-- <div class="sebInnerTit">
                                <span>Q</span> Question
                                <input  type="text" id="urlInput" class="url-input"/>
                                <a @click="copyUrl()" class="url-copy-btn"><span>URL</span>Copy</a>
                            </div>
                            <div class="sebContent">
                                <p>What should I do if I get a "Failed to download update information" message when running update?</p>
                                <div  style="margin-top: 3rem; text-align: center;">
                                    <img src="@/assets/img/cs/common/en_imgs6.png"/>
                                </div>
                            </div> -->
                            <div class="sebInnerTit">
                                <span>A</span> Answer
                                <input  type="text" id="urlInput" class="url-input"/>
                                <a @click="copyUrl()" class="url-copy-btn"><span>URL</span>Copy</a>
                            </div>
                            <div class="sebContent">
                                <p>Please check with the network status when the update fails due to a network error.</p>
                                <p>Other network errors include download speed, ping speed and packet loss.</p>
                            </div>
                        </div>
                        <!-- 공통 주요 문의 7 -->
                        <li id="c7" :class="split == '07' ? 'active':'' "  @click="selectQues('common','m0107')">
                            <span>Q</span>7. What are the common features of TACHYON Internet Security and <br/> &nbsp;&ensp;&emsp;&emsp;&emsp;&emsp; TACHYON Endpoint Security?
                        </li>
                        <div v-if="split == '07'" class="sebContInner">
                            <div class="sebInnerTit">
                                <span>A</span> Answer
                                <input  type="text" id="urlInput" class="url-input"/>
                                <a @click="copyUrl()" class="url-copy-btn"><span>URL</span>Copy</a>
                            </div>
                            <div class="sebContent">
                                <ul>
                                    <li>
                                        - Anti-Virus
                                    </li>
                                    <li>
                                        - Integrity Verification
                                    </li>
                                    <li>
                                        - PC Management
                                    </li>
                                    <li>
                                        - PC Optimization
                                    </li>
                                    <li>
                                        - Engine Update
                                    </li>
                                    <li>
                                        - Log
                                    </li>
                                    <li>
                                        - Additional Features
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <!-- 공통 주요 문의 8 -->
                        <li id="c8" :class="split == '08' ? 'active':'' "  @click="selectQues('common','m0108')">
                            <span>Q</span>8. Several functions were not turned on.
                        </li>
                        <div v-if="split == '08'" class="sebContInner">
                            <div  style="margin-top: 3rem; text-align: center;">
                                <img src="@/assets/img/cs/common/en_imgs7.png" style="width:60%;" />
                                <p class="quesPic"> </p>
                            </div>
                            <div class="sebInnerTit">
                                <span>A</span> Answer
                                <input  type="text" id="urlInput" class="url-input"/>
                                <a @click="copyUrl()" class="url-copy-btn"><span>URL</span>Copy</a>
                            </div>
                            <div class="sebContent">
                                <ul>
                                    <li>
                                        <span class="tit">- Solution 1</span><br/>
                                        <p>Click Danger icon at Home</p>
                                        <img src="@/assets/img/cs/common/en_imgs5.png"/>
                                        <br/>
                                        <br/>
                                    </li>
                                    <li>
                                        <p>Click [Fix] buttons one by one.</p>
                                        <img src="@/assets/img/cs/common/en_imgs10.png"/>
                                        <br/>
                                        <br/>
                                    </li>
                                    <li>
                                        <span class="tit">- Solution 2</span><br/>
                                        <p>Go to Settings > Windows Security > Device security > Core isolation.</p>
                                        <img src="@/assets/img/cs/common/en_imgs8.png"/>
                                        <br/>
                                        <br/>
                                    </li>
                                    <li>
                                        <p>Turn off for Memory integrity.</p>
                                        <img src="@/assets/img/cs/common/en_imgs9.png"/>
                                        <br/>
                                        <br/>
                                    </li>
                                    <li>
                                        <p>Restart Windows.</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </ul>

                </div>
            </ul>

        </div>


        <!--**********************************************************구매 및 라이선스**********************************************************-->
        <!-- 구매 및 라이선스 -->
        <!-- 구매 및 라이선스 구매 1~4 개 FAQ-->
        <div v-if="selContent == 'sel' && num.includes('m01')" class="sebContTit">
            <ul>
                <div class="sebContTit">
                    <ul>
                         <!-- 구매 및 라이선스 구매 1 -->
                        <li id="c1" :class="split == '01' ? 'active':'' "  @click="selectQues('sel','m0101')">
                            <span>Q</span>1. How do I use customer service about payment?
                        </li>
                        <div v-if="split == '01'" class="sebContInner">
                            <div class="sebInnerTit">
                                <span>A</span> Answer
                                <input  type="text" id="urlInput" class="url-input"/>
                                <a @click="copyUrl()" class="url-copy-btn"><span>URL</span>Copy</a>
                            </div>
                            <div class="sebContent">
                                <p>Phone and online (E-Mail) customer service are available.</p>
                                <br/>

                                <p>* Customer Service: +82 1566-0808</p>
                                <p>Available time : Mon - Fri : AM 9 ~ PM 6</p>
                                <br/>
                                <p>*Online(E-Mail)</p>
                                <p>Available through TACHYON homepage at [Product Inquiry]</p>
                                <p>Answers to your inquires will be available later.</p>
                                <p>Customer Service E-mail : <a href="mailto:info@tachyonlab.com">info@tachyonlab.com</a></p>
                            </div>
                        </div>
                        <!-- 구매 및 라이선스 구매 2 -->
                        <li id="c2" :class="split == '02' ? 'active':'' "  @click="selectQues('sel','m0102')">
                            <span>Q</span>2. I cannot pay with my credit card. What should I do?
                        </li>
                        <div v-if="split == '02'" class="sebContInner">
                            <div class="sebInnerTit">
                                <span>A</span> Answer
                                <input  type="text" id="urlInput" class="url-input"/>
                                <a @click="copyUrl()" class="url-copy-btn"><span>URL</span>Copy</a>
                            </div>
                            <div class="sebContent">
                                <p>Sorry, we don’t accept credit cards. Please use PayPal instead.</p>
                            </div>
                        </div>
                        <!-- 구매 및 라이선스 구매 3 -->
                        <li id="c3" :class="split == '03' ? 'active':'' " @click="selectQues('sel','m0103')">
                            <span>Q</span>3. Can I purchase 1copy of TACHYON software and install it on multiple PCs?
                        </li>
                        <div v-if="split == '03'" class="sebContInner">
                            <div class="sebInnerTit">
                                <span>A</span> Answer
                                <input  type="text" id="urlInput" class="url-input"/>
                                <a @click="copyUrl()" class="url-copy-btn"><span>URL</span>Copy</a>
                            </div>
                            <div class="sebContent">
                                <p>For enterprise, product for home is not allowed to purchase or use and please purchase products for business through a product inquiry.</p>
                                <p>For TACHYON products for Home, this product can be installed  up to 1 or 3 PCs according to license type.</p>
                            </div>
                        </div>
                        <!-- 구매 및 라이선스 구매 4 -->
                        <li id="c4" :class="split == '04' ? 'active':'' " @click="selectQues('sel','m0104')">
                            <span>Q</span>4. What is the difference between product for home and enterprise?
                        </li>
                        <div v-if="split == '04'" class="sebContInner">
                            <div class="sebInnerTit">
                                <span>A</span> Answer
                                <input  type="text" id="urlInput" class="url-input"/>
                                <a @click="copyUrl()" class="url-copy-btn"><span>URL</span>Copy</a>
                            </div>
                            <div class="sebContent">
                                <p>The main difference between the product for home and enterprise is the presence of network security and ransomware protection.</p>
                                <br/>
                                <p>In addition to the malware diagnosis feature, home product provides only web security feature that block sites with malicious code distribution history. </p>
                                <br/>
                                <p>Enterprise product provides a firewall for more secure use, as well as blocking and detecting access to unauthorized network intrusions. This software is also recommended to detect and block suspected ransomware. </p>
                            </div>
                        </div>
                    </ul>

                </div>
            </ul>

        </div>

    </div>
</template>

<script>
import { RETURN } from 'core-js/modules/_for-of';


export default {
    name: 'CsContent',
    created : function() {
        this.selContent = this.$route.params.code;
        this.num = this.$route.params.no;
        this.split = this.num.substr(this.num.length - 2);
        this.menu = this.num.substr(0, 3);
    },
    data: function() {
        return {
            selContent : "",
            num : "",
            split : "",
            menu : '',
        }
    },
    methods: {
        selectQues(userType, no) {
            if(userType == this.selContent && no == this.num) {
                window.location.href= '/cs/en/' + userType + '/' + this.menu + '00';
                return;
            }
            window.location.href= '/cs/en/' + userType + '/' + no;

        },
        copyUrl() {
           const urlInput = document.getElementById("urlInput");

            //현재 URL 가져오기
            urlInput.value = window.document.location.href;

            //clipboard 복사
            urlInput.select();
            document.execCommand("copy");
            urlInput.eventUrlInput.blur();
        }
    }
}


</script>
